module.exports = __webpack_public_path__ + "media/DataViz_med.418f3b66.mp4";